import { useAppState } from 'hooks/useAppState';

export const useSheduleEditorState = () => {
  const { sheduleEditorState } = useAppState();

  return sheduleEditorState;
};
